import moment from "moment";
import { BaseEntity, getCachedPlanetEntity, getCachedSchematicEntity } from ".";
import { IGet_characters_character_id_planets_planet_id_ok } from "../service/esiclient";
import { getCachedCharacterEntity } from "./CharacterEntityCache";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class CharacterPlanetDetailEntity extends BaseEntity {
  constructor(id: number, props: any, character_id: any) {
    super(id, props);
    this._dataTypeName = "Character Planet";
    this._character_id = character_id;
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_characters_character_id_planets_planet_id_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      delete entity.properties["id"];
      const characterEntity = await getCachedCharacterEntity(this._character_id);
      if (characterEntity !== null) {
        entity.properties["owner"] = await characterEntity.toJson();
      }
      let planetName = this._id;
      const planetEntity = await getCachedPlanetEntity(this._id);
      if (planetEntity !== null) {
        entity.properties["planet"] = await planetEntity.toJson();
        planetName = planetEntity.props.name;
      }
      let link_array: Excel.CellValue[][] = [];
      if (props.links && props.links.length) {
        for (const i of props.links) {
          link_array.push([
            {
              type: Excel.CellValueType.entity,
              text: "Link #" + i.source_pin_id,
              properties: {
                destination_pin_id: {
                  type: Excel.CellValueType.formattedNumber,
                  basicValue: i.destination_pin_id,
                  numberFormat: "##0",
                },
                link_level: {
                  type: Excel.CellValueType.formattedNumber,
                  basicValue: i.link_level,
                  numberFormat: "##0",
                },
                source_pin_id: {
                  type: Excel.CellValueType.formattedNumber,
                  basicValue: i.source_pin_id,
                  numberFormat: "##0",
                },
              },
            },
          ]);
        }
        /*entity.properties["links"] = {
          type: Excel.CellValueType.array,
          elements: link_array,
        };
        */
      }
      let extractor_array: Excel.CellValue[][] = [];
      let pin_array: Excel.CellValue[][] = [];
      if (props.pins && props.pins.length) {
        for (const i of props.pins) {
          let content_array: Excel.CellValue[][] = [];
          if (i.contents) {
            for (const y of i.contents) {
              const contentType = await getCachedTypeEntity(y.type_id);
              let contentTypeResolved = null;
              if (contentType != null) {
                contentTypeResolved = await contentType.toJson();
              }
              if (contentTypeResolved != null) {
                content_array.push([
                  {
                    type: Excel.CellValueType.entity,
                    text: y.amount + " x " + contentTypeResolved.properties?.name?.basicValue,
                    properties: {
                      amount: {
                        type: Excel.CellValueType.formattedNumber,
                        basicValue: y.amount,
                        numberFormat: "##0",
                      },
                      type: contentTypeResolved,
                    },
                  },
                ]);
              }
            }
          }
          const type = await getCachedTypeEntity(i.type_id);
          let typeResolved = null;
          if (type != null) {
            typeResolved = await type.toJson();
          }
          let schematicResolved = null;
          if (i.schematic_id) {
            const schematicData = await getCachedSchematicEntity(i.schematic_id);
            if (schematicData !== null) schematicResolved = await schematicData.toJson();
          }
          const expiry_time = i.expiry_time ? moment(i.expiry_time) : moment();
          const install_time = i.install_time ? moment(i.install_time) : moment();
          const last_cycle_start = i.last_cycle_start ? moment(i.last_cycle_start) : moment();
          if (typeResolved !== null && i.contents?.length) {
            const nameofpin = typeResolved.properties?.name.basicValue;
            if (i.extractor_details) {
              extractor_array.push([
                {
                  type: Excel.CellValueType.entity,
                  text: nameofpin ? nameofpin.toString() : "Pin #" + i.pin_id,
                  properties: {
                    contents: {
                      type: Excel.CellValueType.array,
                      elements: content_array,
                    },
                    extractor_cycle_time: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.extractor_details?.cycle_time ? i.extractor_details?.cycle_time : 0,
                      numberFormat: "##0",
                    },
                    extractor_heads: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.extractor_details?.heads.length ? i.extractor_details?.heads.length : 0,
                      numberFormat: "##0",
                    },
                    extractor_product_type_id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.extractor_details?.product_type_id ? i.extractor_details?.product_type_id : 0,
                      numberFormat: "##0",
                    },
                    extractor_product_qty_per_cycle: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.extractor_details?.qty_per_cycle ? i.extractor_details?.qty_per_cycle : 0,
                      numberFormat: "##0",
                    },
                    expiry_time: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.expiry_time ? expiry_time.unix() / 86400 + 25569 : 0,
                      numberFormat: i.expiry_time ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    install_time: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.install_time ? install_time.unix() / 86400 + 25569 : 0,
                      numberFormat: i.install_time ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    last_cycle_start: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.last_cycle_start ? last_cycle_start.unix() / 86400 + 25569 : 0,
                      numberFormat: i.last_cycle_start ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.pin_id,
                      numberFormat: "##0",
                    },
                    schematic_id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.schematic_id ? i.schematic_id : 0,
                      numberFormat: "##0",
                    },
                    type: typeResolved,
                  },
                },
              ]);
            } else {
              pin_array.push([
                {
                  type: Excel.CellValueType.entity,
                  text: nameofpin ? nameofpin.toString() : "Pin #" + i.pin_id,
                  properties: {
                    contents: {
                      type: Excel.CellValueType.array,
                      elements: content_array,
                    },
                    factory_schematic_id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.factory_details?.schematic_id ? i.factory_details?.schematic_id : 0,
                      numberFormat: "##0",
                    },
                    expiry_time: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.expiry_time ? expiry_time.unix() / 86400 + 25569 : 0,
                      numberFormat: i.expiry_time ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    install_time: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.install_time ? install_time.unix() / 86400 + 25569 : 0,
                      numberFormat: i.install_time ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    last_cycle_start: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.last_cycle_start ? last_cycle_start.unix() / 86400 + 25569 : 0,
                      numberFormat: i.last_cycle_start ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.pin_id,
                      numberFormat: "##0",
                    },
                    schematic_id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.schematic_id ? i.schematic_id : 0,
                      numberFormat: "##0",
                    },
                    schematic:
                      schematicResolved !== null
                        ? schematicResolved
                        : {
                            type: Excel.CellValueType.string,
                            basicValue: "None",
                          },
                    type: typeResolved,
                  },
                },
              ]);
            }
          } else if (typeResolved) {
            const nameofpin = typeResolved.properties?.name.basicValue;
            if (i.extractor_details) {
              extractor_array.push([
                {
                  type: Excel.CellValueType.entity,
                  text: nameofpin ? nameofpin.toString() : "Pin #" + i.pin_id,
                  properties: {
                    contents: {
                      type: Excel.CellValueType.string,
                      basicValue: "None",
                    },
                    extractor_cycle_time: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.extractor_details?.cycle_time ? i.extractor_details?.cycle_time : 0,
                      numberFormat: "##0",
                    },
                    extractor_heads: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.extractor_details?.heads.length ? i.extractor_details?.heads.length : 0,
                      numberFormat: "##0",
                    },
                    extractor_product_type_id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.extractor_details?.product_type_id ? i.extractor_details?.product_type_id : 0,
                      numberFormat: "##0",
                    },
                    extractor_product_qty_per_cycle: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.extractor_details?.qty_per_cycle ? i.extractor_details?.qty_per_cycle : 0,
                      numberFormat: "##0",
                    },
                    expiry_time: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.expiry_time ? expiry_time.unix() / 86400 + 25569 : 0,
                      numberFormat: i.expiry_time ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    install_time: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.install_time ? install_time.unix() / 86400 + 25569 : 0,
                      numberFormat: i.install_time ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    last_cycle_start: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.last_cycle_start ? last_cycle_start.unix() / 86400 + 25569 : 0,
                      numberFormat: i.last_cycle_start ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.pin_id,
                      numberFormat: "##0",
                    },
                    schematic_id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.schematic_id ? i.schematic_id : 0,
                      numberFormat: "##0",
                    },
                    type: typeResolved,
                  },
                },
              ]);
            } else {
              pin_array.push([
                {
                  type: Excel.CellValueType.entity,
                  text: nameofpin ? nameofpin.toString() : "Pin #" + i.pin_id,
                  properties: {
                    contents: {
                      type: Excel.CellValueType.string,
                      basicValue: "None",
                    },
                    factory_schematic_id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.factory_details?.schematic_id ? i.factory_details?.schematic_id : 0,
                      numberFormat: "##0",
                    },
                    expiry_time: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.expiry_time ? expiry_time.unix() / 86400 + 25569 : 0,
                      numberFormat: i.expiry_time ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    install_time: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.install_time ? install_time.unix() / 86400 + 25569 : 0,
                      numberFormat: i.install_time ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    last_cycle_start: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.last_cycle_start ? last_cycle_start.unix() / 86400 + 25569 : 0,
                      numberFormat: i.last_cycle_start ? "[$-409]m/d/yy h:mm AM/PM;@" : "##0",
                    },
                    id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.pin_id,
                      numberFormat: "##0",
                    },
                    schematic_id: {
                      type: Excel.CellValueType.formattedNumber,
                      basicValue: i.schematic_id ? i.schematic_id : 0,
                      numberFormat: "##0",
                    },
                    schematic:
                      schematicResolved != null
                        ? schematicResolved
                        : {
                            type: Excel.CellValueType.string,
                            basicValue: "None",
                          },
                    type: typeResolved,
                  },
                },
              ]);
            }
          }
          if (pin_array.length) {
            entity.properties["pins"] = {
              type: Excel.CellValueType.array,
              elements: pin_array,
            };
          }
          if (extractor_array.length) {
            entity.properties["extractors"] = {
              type: Excel.CellValueType.array,
              elements: extractor_array,
            };
          }
        }
      }

      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: "Details for " + planetName,
      };
      entity.text = "Details for " + planetName;
    }
    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
    };

    return entity;
  }
}
